module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-01.a2d8c378.png";